import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = '/api';
const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c', GREEN = '#22a06b';

export default function AppSearch() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [allSalons, setAllSalons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        let lat = 24.95, lng = 84.08;
        try {
          const pos = await new Promise((res, rej) => navigator.geolocation.getCurrentPosition(res, rej, { timeout: 6000 }));
          lat = pos.coords.latitude; lng = pos.coords.longitude;
        } catch (e) {}
        const r = await axios.get(`${API}/salons/nearby`, { params: { lat, lng, radius: 15 }, timeout: 12000 });
        setAllSalons(Array.isArray(r.data) ? r.data : (r.data?.salons || []));
      } catch (e) { setAllSalons([]); }
      setLoading(false);
    };
    load();
  }, []);

  const ql = q.trim().toLowerCase();
  const results = ql === '' ? allSalons : allSalons.filter(s => {
    const name = (s.salon_name || s.name || '').toLowerCase();
    const type = (s.business_type || '').toLowerCase();
    let svc = '';
    try {
      const services = Array.isArray(s.services) ? s.services : Object.values(s.services || {});
      svc = services.map(x => (x.name || '')).join(' ').toLowerCase();
    } catch (e) {}
    return name.includes(ql) || type.includes(ql) || svc.includes(ql);
  });

  const quickTags = ['Haircut', 'Facial', 'Makeup', 'Spa', 'Color', 'Salon', 'Parlour'];

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fb', maxWidth: 480, margin: '0 auto', paddingBottom: 80 }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '18px 16px 20px', position: 'sticky', top: 0, zIndex: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span onClick={() => navigate('/app/home')} style={{ fontSize: 24, cursor: 'pointer' }}>‹</span>
          <div style={{ flex: 1, background: '#fff', borderRadius: 14, display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px' }}>
            <span style={{ color: GREY }}>🔍</span>
            <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Salon, service ya style..."
              style={{ border: 'none', outline: 'none', fontSize: 15, flex: 1, color: INK }} />
            {q && <span onClick={() => setQ('')} style={{ color: GREY, cursor: 'pointer', fontSize: 18 }}>✕</span>}
          </div>
        </div>
      </div>

      {/* quick tags */}
      {q === '' && (
        <div style={{ padding: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: GREY, marginBottom: 10 }}>Popular searches</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {quickTags.map((t, i) => (
              <span key={i} onClick={() => setQ(t)} style={{ background: '#fff', border: '1px solid #f0f0f4', borderRadius: 20, padding: '8px 16px', fontSize: 13, fontWeight: 600, color: INK, cursor: 'pointer' }}>{t}</span>
            ))}
          </div>
        </div>
      )}

      <div style={{ padding: '8px 16px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: GREY }}>Loading...</div>
        ) : results.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: GREY, fontSize: 14 }}>Kuch nahi mila "{q}" ke liye.<br />Doosra shabd try karें.</div>
        ) : (
          <>
            <div style={{ fontSize: 13, color: GREY, marginBottom: 12 }}>{results.length} salon mile</div>
            {results.map((s, i) => (
              <div key={i} onClick={() => {
                const sid = s.salon_id || s.id;
                sessionStorage.setItem('app_salon_' + sid, JSON.stringify(s));
                navigate('/app/salon/' + sid);
              }} style={{ background: '#fff', borderRadius: 14, padding: 12, display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12, cursor: 'pointer', boxShadow: '0 2px 8px rgba(28,28,40,.05)' }}>
                <div style={{ width: 60, height: 60, borderRadius: 12, background: s.photo_url ? `url(${s.photo_url}) center/cover` : 'linear-gradient(135deg,#e2c4b8,#c99d8a)', flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 15, fontWeight: 700, color: INK }}>{s.salon_name || s.name}</div>
                  <div style={{ fontSize: 12, color: GREY, marginTop: 3 }}>{s.business_type === 'parlour' ? 'Parlour' : 'Salon'} · {s.distanceKm ? `${s.distanceKm.toFixed(1)} km` : 'Near'}</div>
                </div>
                <span style={{ background: GREEN, color: '#fff', fontSize: 11, fontWeight: 800, padding: '2px 7px', borderRadius: 6 }}>{s.rating || '4.2'}★</span>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
